import { useTranslation } from '@ecomm/i18n'
import { ComparisonFooter } from '../ComparisonFooter'
import { ComparisonFooterCell } from '../ComparisonFooterCell'

export function Footer() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonFooter label={t('microtext.price')}>
      <ComparisonFooterCell>
        {t('microtext.price-per-day', {
          value: t('plan-price-per-day.core-business')
        })}
      </ComparisonFooterCell>
      <ComparisonFooterCell>
        {t('microtext.price-per-day', {
          value: t('plan-price-per-day.pro-business')
        })}
      </ComparisonFooterCell>
      <ComparisonFooterCell>
        {t('microtext.price-per-day', {
          value: t('plan-price-per-day.pro-plus-business')
        })}
      </ComparisonFooterCell>
    </ComparisonFooter>
  )
}
